export const Germany = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_11011_7939)">
                <rect
                    x="2"
                    y="1.99997"
                    width="20"
                    height="20"
                    rx="10"
                    fill="white"
                />
                <path
                    d="M2.62207 15.4791C4.035 19.287 7.70043 22.0008 12.0001 22.0008C16.2997 22.0008 19.9652 19.287 21.3781 15.4791L12.0001 14.6095L2.62207 15.4791Z"
                    fill="#FFDA44"
                />
                <path
                    d="M12.0001 2.00061C7.70043 2.00061 4.035 4.71436 2.62207 8.52237L12.0001 9.3919L21.3781 8.52233C19.9652 4.71436 16.2997 2.00061 12.0001 2.00061Z"
                    fill="#101114"
                />
                <path
                    d="M2.62199 8.52144C2.22004 9.60476 2 10.7765 2 11.9997C2 13.2229 2.22004 14.3946 2.62199 15.4779H21.378C21.78 14.3946 22 13.2229 22 11.9997C22 10.7765 21.78 9.60476 21.378 8.52144H2.62199Z"
                    fill="#D80027"
                />
            </g>
            <rect
                x="2.5"
                y="2.49997"
                width="19"
                height="19"
                rx="9.5"
                stroke="white"
            />
            <defs>
                <clipPath id="clip0_11011_7939">
                    <rect
                        x="2"
                        y="1.99997"
                        width="20"
                        height="20"
                        rx="10"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
